export class project{
    CLIENT_ID: number;
    ID: number;
    NAME: string;
    DESCRIPTION: string;
    ESTIMATED_MANDAYS: number;
    ICON:string;
    START_DATE: string;
    END_DATE: string;
    ATTACHMENT_1:string;
    ATTACHMENT_2:string;
    ATTACHMENT_3:string;
    STATUS:string= "A";
    PROJECT_CLIENT_ID: number;
    ESTIMATED_HOURS: number;
    ESTIMATED_MINUTES: number;
    ESTIMATED_SECONDS: number;
    ABBREVATION: string;
    IS_ACTIVE: boolean;
    IS_BILLABLE: boolean;
    IS_GENERATE_REPORT: boolean;
    SEQ_NO: number = 0;
    RESERCH_DEVLOPMENT: boolean;
    TRAINING: boolean;
    OTHER: boolean;
    NON_BILABLE: boolean;

}